<template>
  <button
    class="rounded-full border border-purple-950 p-1 text-sm text-purple-950"
    aria-label="Close menu"
    @click="emit('close')"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  </button>
</template>
<script setup lang="ts">
const emit = defineEmits<{
  (e: "close"): void;
}>();
</script>
